<template>
  <div class="mainDash"
    :style="{ backgroundImage: 'url(' + background_image + ')' }">
    <v-container id="app">
      <div style="position: absolute; top: 10px; right: 20px">
        v.{{ this.$store.state.versione }}
      </div>
      <svg id="icons">
        <symbol id="pdfconvert" viewBox="0 0 32 32">
          <g>
            <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M12,10.5H13V13.5H12V10.5M7,11.5H8V10.5H7V11.5M20,6V18A2,2 0 0,1 18,20H6A2,2 0 0,1 4,18V6A2,2 0 0,1 6,4H18A2,2 0 0,1 20,6M9.5,10.5A1.5,1.5 0 0,0 8,9H5.5V15H7V13H8A1.5,1.5 0 0,0 9.5,11.5V10.5M14.5,10.5A1.5,1.5 0 0,0 13,9H10.5V15H13A1.5,1.5 0 0,0 14.5,13.5V10.5M18.5,9H15.5V15H17V13H18.5V11.5H17V10.5H18.5V9Z"
              />
            </svg>
          </g>
        </symbol>
        <symbol id="listadipicking" viewBox="0 0 32 32">
          <g>
            <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15"
              />
            </svg>
          </g>
        </symbol>
        <symbol id="distintabase" viewBox="0 0 32 32">
          <g>
            <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M13,15L15.5,17.5L16.92,16.08L12,11.16L7.08,16.08L8.5,17.5L11,15V21H13V15M3,3H21V5H3V3M3,7H13V9H3V7Z"
              />
            </svg>
          </g>
        </symbol>
        <symbol id="articolo" viewBox="0 0 32 32">
          <g>
            <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M11.97,19.88C10.93,20.26 9.78,19.72 9.4,18.69C9,17.65 9.55,16.5 10.59,16.13C11.63,15.75 12.78,16.28 13.16,17.31C13.54,18.35 13,19.5 11.97,19.88M9.9,14.25C7.83,15 6.76,17.3 7.5,19.38C8.28,21.45 10.58,22.5 12.66,21.75C14.73,21 15.79,18.7 15.04,16.63C14.28,14.55 11.97,13.5 9.9,14.25M15.94,4.58L9.37,7L10.75,10.74L17.32,8.33M20.32,13.62L15.54,15.37C15.71,15.66 15.85,15.96 15.97,16.28C16.09,16.6 16.17,16.93 16.22,17.25L21,15.5M19.54,8.58L11.09,11.68L11.58,13C12.83,13.09 14,13.64 14.89,14.55L20.92,12.34M2,2V4H5.09L8.66,13.75C8.94,13.57 9.24,13.43 9.56,13.31C9.88,13.19 10.21,13.11 10.53,13.06L6.5,2"
              />
            </svg>
          </g>
        </symbol>
        <symbol id="consuntivi" viewBox="0 0 390.7 390.7">
          <g>
            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M19,13H3V11H19L15,7L16.4,5.6L22.8,12L16.4,18.4L15,17L19,13M3,6H13V8H3V6M13,16V18H3V16H13Z"
              />
            </svg>
          </g>
        </symbol>
        <symbol id="diario" viewBox="0 0 32 32">
          <g>
            <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M4 7H2V21C2 22.1 2.9 23 4 23H18V21H4M20 3H16.8C16.4 1.8 15.3 1 14 1C12.7 1 11.6 1.8 11.2 3H8C6.9 3 6 3.9 6 5V17C6 18.1 6.9 19 8 19H20C21.1 19 22 18.1 22 17V5C22 3.9 21.1 3 20 3M14 3C14.6 3 15 3.5 15 4C15 4.5 14.5 5 14 5C13.5 5 13 4.5 13 4C13 3.5 13.4 3 14 3M12.3 15.1L9 11.8L10.4 10.4L12.3 12.3L17.6 7L19 8.4"
              />
            </svg>
          </g>
        </symbol>
        <symbol id="checklist" viewBox="0 0 32 32">
          <g>
            <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M4 8H2V2H4V8M2 22H4V16H2V22M3 10C1.9 10 1 10.9 1 12C1 13.11 1.9 14 3 14C4.11 14 5 13.11 5 12C5 10.9 4.11 10 3 10M24 6V18C24 19.11 23.11 20 22 20H10C8.9 20 8 19.11 8 18V14L6 12L8 10V6C8 4.89 8.9 4 10 4H22C23.11 4 24 4.89 24 6M19.75 10.33L18.59 8.92L15 12.5L13.41 10.92L12.25 12.08L15 15.08L19.75 10.33Z" />
            </svg>
          </g>
        </symbol>
        <symbol id="impostazioni" viewBox="0 0 32 32">
         <g>
          <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M3 3H17C18.11 3 19 3.9 19 5V12.08C17.45 11.82 15.92 12.18 14.68 13H11V17H12.08C11.97 17.68 11.97 18.35 12.08 19H3C1.9 19 1 18.11 1 17V5C1 3.9 1.9 3 3 3M3 7V11H9V7H3M11 7V11H17V7H11M3 13V17H9V13H3M22.78 19.32L21.71 18.5C21.73 18.33 21.75 18.17 21.75 18S21.74 17.67 21.71 17.5L22.77 16.68C22.86 16.6 22.89 16.47 22.83 16.36L21.83 14.63C21.77 14.5 21.64 14.5 21.5 14.5L20.28 15C20 14.82 19.74 14.65 19.43 14.53L19.24 13.21C19.23 13.09 19.12 13 19 13H17C16.88 13 16.77 13.09 16.75 13.21L16.56 14.53C16.26 14.66 15.97 14.82 15.71 15L14.47 14.5C14.36 14.5 14.23 14.5 14.16 14.63L13.16 16.36C13.1 16.47 13.12 16.6 13.22 16.68L14.28 17.5C14.26 17.67 14.25 17.83 14.25 18S14.26 18.33 14.28 18.5L13.22 19.32C13.13 19.4 13.1 19.53 13.16 19.64L14.16 21.37C14.22 21.5 14.35 21.5 14.47 21.5L15.71 21C15.97 21.18 16.25 21.35 16.56 21.47L16.75 22.79C16.77 22.91 16.87 23 17 23H19C19.12 23 19.23 22.91 19.25 22.79L19.44 21.47C19.74 21.34 20 21.18 20.28 21L21.5 21.5C21.64 21.5 21.77 21.5 21.84 21.37L22.84 19.64C22.9 19.53 22.87 19.4 22.78 19.32M18 19.5C17.17 19.5 16.5 18.83 16.5 18S17.18 16.5 18 16.5 19.5 17.17 19.5 18 18.84 19.5 18 19.5Z" />
            </svg>
          </g>
        </symbol>
        <symbol id="impostazioni" viewBox="0 0 32 32">
         <g>
          <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M3 3H17C18.11 3 19 3.9 19 5V12.08C17.45 11.82 15.92 12.18 14.68 13H11V17H12.08C11.97 17.68 11.97 18.35 12.08 19H3C1.9 19 1 18.11 1 17V5C1 3.9 1.9 3 3 3M3 7V11H9V7H3M11 7V11H17V7H11M3 13V17H9V13H3M22.78 19.32L21.71 18.5C21.73 18.33 21.75 18.17 21.75 18S21.74 17.67 21.71 17.5L22.77 16.68C22.86 16.6 22.89 16.47 22.83 16.36L21.83 14.63C21.77 14.5 21.64 14.5 21.5 14.5L20.28 15C20 14.82 19.74 14.65 19.43 14.53L19.24 13.21C19.23 13.09 19.12 13 19 13H17C16.88 13 16.77 13.09 16.75 13.21L16.56 14.53C16.26 14.66 15.97 14.82 15.71 15L14.47 14.5C14.36 14.5 14.23 14.5 14.16 14.63L13.16 16.36C13.1 16.47 13.12 16.6 13.22 16.68L14.28 17.5C14.26 17.67 14.25 17.83 14.25 18S14.26 18.33 14.28 18.5L13.22 19.32C13.13 19.4 13.1 19.53 13.16 19.64L14.16 21.37C14.22 21.5 14.35 21.5 14.47 21.5L15.71 21C15.97 21.18 16.25 21.35 16.56 21.47L16.75 22.79C16.77 22.91 16.87 23 17 23H19C19.12 23 19.23 22.91 19.25 22.79L19.44 21.47C19.74 21.34 20 21.18 20.28 21L21.5 21.5C21.64 21.5 21.77 21.5 21.84 21.37L22.84 19.64C22.9 19.53 22.87 19.4 22.78 19.32M18 19.5C17.17 19.5 16.5 18.83 16.5 18S17.18 16.5 18 16.5 19.5 17.17 19.5 18 18.84 19.5 18 19.5Z" />
            </svg>
          </g>
        </symbol>
        <symbol id="famigliearticolo" viewBox="0 0 32 32">
         <g>
          <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M19.5 17C19.37 17 19.24 17 19.11 17.04L17.5 13.79C17.95 13.34 18.25 12.71 18.25 12C18.25 10.62 17.13 9.5 15.75 9.5C15.62 9.5 15.5 9.5 15.36 9.54L13.73 6.29C14.21 5.84 14.5 5.21 14.5 4.5C14.5 3.12 13.38 2 12 2S9.5 3.12 9.5 4.5C9.5 5.21 9.79 5.84 10.26 6.29L8.64 9.54C8.5 9.5 8.38 9.5 8.25 9.5C6.87 9.5 5.75 10.62 5.75 12C5.75 12.71 6.05 13.34 6.5 13.79L4.89 17.04C4.76 17 4.63 17 4.5 17C3.12 17 2 18.12 2 19.5C2 20.88 3.12 22 4.5 22S7 20.88 7 19.5C7 18.8 6.71 18.16 6.24 17.71L7.86 14.46C8 14.5 8.12 14.5 8.25 14.5C8.38 14.5 8.5 14.5 8.64 14.46L10.27 17.71C9.8 18.16 9.5 18.8 9.5 19.5C9.5 20.88 10.62 22 12 22S14.5 20.88 14.5 19.5C14.5 18.12 13.38 17 12 17C11.87 17 11.74 17 11.61 17.04L10 13.79C10.46 13.34 10.75 12.71 10.75 12S10.46 10.66 10 10.21L11.61 6.96C11.74 7 11.87 7 12 7S12.26 7 12.39 6.96L14 10.21C13.55 10.66 13.25 11.3 13.25 12C13.25 13.38 14.37 14.5 15.75 14.5C15.88 14.5 16 14.5 16.14 14.46L17.77 17.71C17.3 18.16 17 18.8 17 19.5C17 20.88 18.12 22 19.5 22S22 20.88 22 19.5C22 18.12 20.88 17 19.5 17Z" />
            </svg>
          </g>
        </symbol>
        <symbol id="modificamultipla" viewBox="0 0 32 32">
         <g>
          <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M2,6V8H14V6H2M2,10V12H14V10H2M20.04,10.13C19.9,10.13 19.76,10.19 19.65,10.3L18.65,11.3L20.7,13.35L21.7,12.35C21.92,12.14 21.92,11.79 21.7,11.58L20.42,10.3C20.31,10.19 20.18,10.13 20.04,10.13M18.07,11.88L12,17.94V20H14.06L20.12,13.93L18.07,11.88M2,14V16H10V14H2Z" />
            </svg>
          </g>
        </symbol>
        <symbol id="emproduzione2" viewBox="0 0 390.7 390.7">
          <g>
            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M14 18V16L10 19.5L14 23V21H17V18H14M22 15.5L18 12V14H15V17H18V19L22 15.5M21.66 8.73L19.66 5.27C19.54 5.05 19.28 4.96 19.05 5.05L16.56 6.05C16.05 5.64 15.5 5.31 14.87 5.05L14.5 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.5 2.42L9.13 5.07C8.5 5.33 7.96 5.66 7.44 6.07L5 5.05C4.77 4.96 4.5 5.05 4.39 5.27L2.39 8.73C2.26 8.94 2.31 9.22 2.5 9.37L4.57 11C4.53 11.33 4.5 11.67 4.5 12C4.5 12.33 4.53 12.67 4.57 13L2.46 14.63C2.26 14.78 2.21 15.06 2.34 15.27L4.34 18.73C4.45 19 4.74 19.11 5 19L5 19L7.5 18C7.74 18.19 8 18.37 8.26 18.53L11.77 15.53C9.84 15.4 8.38 13.73 8.5 11.8C8.65 9.87 10.32 8.41 12.25 8.55C13.69 8.64 14.92 9.62 15.35 11H19.43L21.54 9.37C21.73 9.22 21.78 8.94 21.66 8.73Z"
              />
            </svg>
          </g>
        </symbol>
        <symbol id="emlayouteditor" viewBox="0 0 390.7 390.7">
          <g>
            <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M13,17H17V13H19V17H23V19H19V23H17V19H13V17M11,17V19H9V17H11M7,17V19H5V17H7M19,9V11H17V9H19M19,5V7H17V5H19M15,5V7H13V5H15M11,5V7H9V5H11M7,5V7H5V5H7M7,13V15H5V13H7M7,9V11H5V9H7Z"
              />
            </svg>
          </g>
        </symbol>
        <!-- <symbol id="gestionefamiglie" viewBox="0 0 32 32">
          <g>
            <svg
              class="shadow"
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
            >
              <path fill="currentColor" d="M3 3H17C18.11 3 19 3.9 19 5V12.08C17.45 11.82 15.92 12.18 14.68 13H11V17H12.08C11.97 17.68 11.97 18.35 12.08 19H3C1.9 19 1 18.11 1 17V5C1 3.9 1.9 3 3 3M3 7V11H9V7H3M11 7V11H17V7H11M3 13V17H9V13H3M22.78 19.32L21.71 18.5C21.73 18.33 21.75 18.17 21.75 18S21.74 17.67 21.71 17.5L22.77 16.68C22.86 16.6 22.89 16.47 22.83 16.36L21.83 14.63C21.77 14.5 21.64 14.5 21.5 14.5L20.28 15C20 14.82 19.74 14.65 19.43 14.53L19.24 13.21C19.23 13.09 19.12 13 19 13H17C16.88 13 16.77 13.09 16.75 13.21L16.56 14.53C16.26 14.66 15.97 14.82 15.71 15L14.47 14.5C14.36 14.5 14.23 14.5 14.16 14.63L13.16 16.36C13.1 16.47 13.12 16.6 13.22 16.68L14.28 17.5C14.26 17.67 14.25 17.83 14.25 18S14.26 18.33 14.28 18.5L13.22 19.32C13.13 19.4 13.1 19.53 13.16 19.64L14.16 21.37C14.22 21.5 14.35 21.5 14.47 21.5L15.71 21C15.97 21.18 16.25 21.35 16.56 21.47L16.75 22.79C16.77 22.91 16.87 23 17 23H19C19.12 23 19.23 22.91 19.25 22.79L19.44 21.47C19.74 21.34 20 21.18 20.28 21L21.5 21.5C21.64 21.5 21.77 21.5 21.84 21.37L22.84 19.64C22.9 19.53 22.87 19.4 22.78 19.32M18 19.5C17.17 19.5 16.5 18.83 16.5 18S17.18 16.5 18 16.5 19.5 17.17 19.5 18 18.84 19.5 18 19.5Z" />
            </svg>
          </g>
        </symbol> -->
      </svg>
      <Radial_Menu
        ref="radialMenu"
        @clicked="menuClicked"
        @touchend="menuClicked"
        :menu-items="menuItems"
        :size="altezza - 55"
      ></Radial_Menu>
      <v-snackbar
        content-class="snackbar"
        :color="snackbar_background"
        right
        v-model="snackbar"
        :timeout="3000"
      >
        <v-icon :size="64">{{ snackbar_icon }}</v-icon>
        <h2 class="ml-16">{{ snackbar_text }}</h2>

        <v-btn
          @click="snackbar = false"
          fab
          dark
          text
          small
          style="
            margin-top: -6rem;
            float: right !important;
            margin-right: -1rem !important;
          "
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import RadialMenu from "./ElectricalDashComp/ElectricalRadialMenu.vue";
import background_default from "../../assets/Ind.jpg";

export default {
  name: "app",
  data: function () {
    return {
      // Variabili d'appoggio
      altezza: 0,

      // Modal
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_text: "",
      background_image: "",

      // Array
      menuItems: [],
    };
  },
  computed: {
    id_profilo() {
      return localStorage.id_profilo;
    },
  },
  methods: {
    isModuloAutorizzato(id_modulo_menu) {
      let menu_presente = false;
      this.$store.state.menu_sx.forEach((elem) => {
        if (elem.id_modulo_menu === id_modulo_menu) {
          menu_presente = true;
        }
      });

      if (menu_presente === true) {
        return true;
      } else {
        return false;
      }
    },
    goToManutenzione() {
      this.$router.push("/home/manutenzione/main");
    },
    menuClicked: function (menuItem) {
      this.$router.push(menuItem.path);
    },
    openMenu: function () {
      this.$refs.radialMenu.open();
    },
    closeMenu: function () {
      this.$refs.radialMenu.close();
    },
    getBackground() {
      let request = {
        controller: "Token",
        method: "POST",
        richiesta: {
          action: "getbackgroundmodulo",
          token: localStorage.getItem("user_token"),
          id_modulo: localStorage.id_modulo_selezionato,
          filter: "validita=1",
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          if (res.data.result.length > 0) {
            if (res.data.result.length > 0)
              this.background_image = res.data.result[0].sfondo;
            else this.background_image = background_default;
          } else {
            this.background_image = background_default;
          }
        }
      });
    },
  },
  created() {
    // Popolo il radial menu.
    let menuArr = JSON.parse(localStorage.menu);

    for (let index = 0; index < menuArr.length; index++) {
      if (menuArr[index].text != "Manutenzione") {
        const element = menuArr[index];
        let strval = "";

        const newEl = {};

        newEl.id = element.des;
        strval = element.text.toLowerCase();

        newEl.title = strval.charAt(0).toUpperCase() + strval.slice(1);

        newEl.title.charAt(0).toUpperCase();

        newEl.icon = `#${element.des}`.toLowerCase().replaceAll(" ", "");

        newEl.path = element.path;
        if (newEl.id != "dashboard electrical") {
          this.menuItems.push(newEl);
        }
      }
    }

    // if (localStorage.id_profilo != 3 && localStorage.id_profilo != 4) {
    //   this.menuItems = [
    //     {
    //       id: "Richieste",
    //       title: "Richieste",
    //       icon: "#richieste",
    //     },
    //     {
    //       id: "Interventi",
    //       title: "Gestione Intervento",
    //       icon: "#interventi",
    //     },
    //     {
    //       id: "Regole",
    //       title: "Regole",
    //       icon: "#regole",
    //     },
    //     {
    //       id: "Attivita",
    //       title: "Attività",
    //       icon: "#attivita",
    //     },
    //     // {
    //     //   id: "ManutenzioneMacchinari",
    //     //   title: "Gestione Macchinari",
    //     //   icon: "#manutenzionemacchinari",
    //     // },
    //     {
    //       id: "Anagrafiche",
    //       title: "Anagrafiche",
    //       icon: "#anagrafiche",
    //     },
    //     {
    //       id: "GestioneSediFornitori",
    //       title: "Gestione Luoghi d'Intervento/ Fornitori",
    //       icon: "#gestionesedifornitori",
    //     },
    //     {
    //       id: "ManutenzioneRecursiva",
    //       title: "Manutenzione Recursiva",
    //       icon: "#manutenzionerecursiva",
    //     },
    //   ];
    //   // } else {
    //   //   this.menuItems = [
    //   //     {
    //   //       id: "Interventi",
    //   //       title: "Gestione Intervento",
    //   //       icon: "#interventi",
    //   //     },
    //   //     {
    //   //       id: "Attivita",
    //   //       title: "Attività",
    //   //       icon: "#attivita",
    //   //     },
    //   //     {
    //   //       id: "Anagrafiche",
    //   //       title: "Anagrafiche",
    //   //       icon: "#anagrafiche",
    //   //     },
    //   //     {
    //   //       id: "GestioneSediFornitori",
    //   //       title: "Gestione Luoghi d'Intervento/ Fornitori",
    //   //       icon: "#gestionesedifornitori",
    //   //     },
    //   //   ];
    // }
  },
  mounted() {
    this.getBackground();
    let that = this;

    this.altezza = window.innerHeight;

    window.addEventListener("resize", function () {
      that.altezza = window.innerHeight;
    });
  },
  components: {
    Radial_Menu: RadialMenu,
  },
  watch: {},
};
</script>

<style scoped>
.allegati {
  width: 1rem !important;
  height: 1rem !important;
}

.icons {
  width: 15rem !important;
  height: 5rem !important;
}

.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
}

#icons {
  display: none;
  size: 16px;
}

#app {
  font-family: Arial, sans-serif;
  font-size: 13px;
  color: white;
}

div.info {
  margin: 15px 0;
}

div.info * {
  color: white;
  text-shadow: 1px 1px 0 #000000d0;
}

.shadow {
  -webkit-filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  /* Similar syntax to box-shadow */
}

.mainDash {
  width: 100% !important;

  background-color: #cccccc; /* Used if the image is unavailable */
  height: 100% !important; /* You must set a specified height */
  background-position: cover; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
  overflow: hidden !important; /* Resize the background image to cover the entire container */
}
svg #shadow {
  transition: all 0.65s;
  opacity: 1;
}
svg:hover #shadow {
  opacity: 0;
}
symbol:hover {
  color: aliceblue;
  box-shadow: 1000px;
}
</style>
